import { Component } from "@angular/core";
import { Icon } from "../utils/icon/icon";

@Component({
  selector: "loader",
  imports: [Icon],
  templateUrl: "./loader.html",
})
export class Loader {}
